import Full from '~/components/layout/Full';
import Message from '~/components/Message';
import NavigationButton from '~/components/interactive/NavigationButton';
import { TenantBrandProvider } from '~/tenants/common/TenantContextProvider';
import { TenantBrand } from '~/tenants/common/registry';
import { Row } from '~/components/layout/Sections';

export default function CustomerPortalDisabled(props: {
  message: string;
  brand?: TenantBrand;
  compact?: boolean;
}) {
  if (props.compact) {
    return (
      <>
        <Message type="info">{props.message}</Message>
        <Row between className="pt-4">
          <NavigationButton to="/login" variant="outline">
            Back to Login
          </NavigationButton>
        </Row>
      </>
    );
  }

  const brand = props.brand!;

  return (
    <TenantBrandProvider brand={brand}>
      <Full>
        <div className="flex max-sm:flex-col min-h-full">
          <div className="flex items-col items-end sm:items-center justify-center sm:px-8 lg:px-16 xl:px-32 max-sm:py-8 sm:flex-1">
            <img src={brand.logoVector ?? brand.logoRaster} className="max-w-64 max-sm:max-h-20" alt={brand.name} />
          </div>
          <div className="bg-white flex flex-col items-col items-center sm:justify-center p-8 lg:px-16 xl:px-32 flex-1">
            <div className="max-w-md w-full space-y-4">
              <Message type="info">{props.message}</Message>
              <NavigationButton to="/logout" variant="outline">
                Logout
              </NavigationButton>
            </div>
          </div>
        </div>
      </Full>
    </TenantBrandProvider>
  );
}
